import { Link, Navigate, useParams } from "react-router-dom";
import { ARTICLE_SECTIONS, HUB_ROLES, getSettings, getVisibility, listArticles } from "@hub";
import { AGENT_LOGIN_URL, BROKER_LOGIN_URL, appUrl } from "../config";
import { useHubVisitor, withVisitor } from "../hubContext";

const DESK_LINKS = {
  buyer: [
    { href: appUrl("/"), label: "Buyer’s Checklist (REChecklist)" },
    { to: "/manuals/buyer", label: "Buyer Manual" },
    { to: "/vendors/client", label: "Client vendors" },
  ],
  seller: [
    { href: appUrl("/seller/home"), label: "Seller’s Checklist (REChecklist)" },
    { to: "/manuals/seller", label: "Seller Manual" },
    { to: "/vendors/client", label: "Client vendors" },
  ],
  agent: [
    { href: AGENT_LOGIN_URL, label: "Agent desk login" },
    { to: "/manuals/agent", label: "Agent Manual" },
    { to: "/support/tour", label: "Guided Tour" },
    { to: "/vendors/pro", label: "Pro vendors" },
  ],
  broker: [
    { href: BROKER_LOGIN_URL, label: "Broker desk login" },
    { to: "/manuals/broker", label: "Broker Manual" },
    { to: "/support/tour", label: "Guided Tour" },
    { to: "/events", label: "Events" },
  ],
  admin: [
    { href: appUrl("/admin"), label: "Admin desk" },
    { href: appUrl("/admin/controls"), label: "Admin Controls" },
    { to: "/manuals", label: "Role manuals" },
    { to: "/vendors", label: "Vendor hub" },
    { to: "/events", label: "Event platform" },
  ],
};

export default function SupportRole() {
  const { role } = useParams();
  const visitor = useHubVisitor();
  if (!HUB_ROLES.includes(role)) return <Navigate to={withVisitor("/support", visitor)} replace />;

  const visibility = getVisibility();
  if (visibility[role] === false) return <Navigate to={withVisitor("/support", visitor)} replace />;

  const settings = getSettings();
  const articles = listArticles().filter((item) => item.role === role);
  const links = DESK_LINKS[role] || [];

  return (
    <article>
      <p className="muted">
        <Link to={withVisitor("/support", visitor)}>All support</Link>
        {" · "}
        <Link to={withVisitor("/manuals", visitor)}>User manuals</Link>
      </p>
      <h1>{role[0].toUpperCase() + role.slice(1)} support</h1>
      <p className="lead">{settings.support_intro}</p>
      <p className="muted">
        Guides, tutorials, troubleshooting, and best practices for this role. DreamHome Journey does
        not grant or verify a real-estate license.
      </p>

      {ARTICLE_SECTIONS.map((section) => {
        const items = articles.filter((item) => item.section === section.id);
        return (
          <section key={section.id} className="hub-section">
            <h2>{section.label}</h2>
            {items.length ? (
              items.map((item) => (
                <div key={item.id} className="card" style={{ marginBottom: "0.85rem" }}>
                  <h3>{item.title}</h3>
                  <p>{item.body}</p>
                </div>
              ))
            ) : (
              <div className="card placeholder-frame">
                <p>More {section.label.toLowerCase()} for {role} will expand here. The signed-in role manual already covers the desk.</p>
              </div>
            )}
          </section>
        );
      })}

      <section className="hub-section">
        <h2>Links to both sites</h2>
        <div className="card-grid">
          {links.map((item) => (
            <section key={item.label} className="card">
              <h3>{item.label}</h3>
              <p>
                {item.href ? (
                  <a href={item.href}>Open</a>
                ) : (
                  <Link to={withVisitor(item.to, visitor)}>Open</Link>
                )}
              </p>
            </section>
          ))}
        </div>
      </section>
    </article>
  );
}
